import { getTimezone } from "@sourcewhale/shared/src/assets/js/src/general/utils";
import { swRequest } from "@sourcewhale/shared/src/svelte/api/sw-request";

export const signUp = ({ provider, utm }) =>
  swRequest({
    path: "/api/signin/create_url",
    method: "POST",
    body: {
      timezone: getTimezone(),
      provider,
      email: null,
      noScope: "",
      allowTeamCreation: true,
      utm,
    },
  });
